import { trapFocus, removeTrapFocus } from "./trap-focus.js";

/**
 * Modal Opener Component
 */
class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) {
      return;
    }

    button.addEventListener("click", () => {
      const modal = document.getElementById(this.getAttribute("data-modal"));

      if (modal) {
        modal.show(button);
      }
    });
  }
}

if (!customElements.get("modal-opener")) {
  customElements.define("modal-opener", ModalOpener);
}

/**
 * Modal Dialog Component
 */
class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('[id^="ModalClose-"]').forEach((elm) =>
      elm.addEventListener("click", this.hide.bind(this, false))
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") {
        this.hide();
      }
    });
  }

  connectedCallback() {
    if (this.moved) {
      return;
    }

    this.moved = true;
    this.style.display = "block";
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    document.body.classList.add("overflow-hidden");

    this.setAttribute("open", "");
    trapFocus(this, this.querySelector('[role="dialog"]'));
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
  }
}
if (!customElements.get("modal-dialog")) {
  customElements.define("modal-dialog", ModalDialog);
}
